import React, { useState, useEffect, useRef } from "react";
import { IoIosSearch, IoIosArrowRoundBack } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../axiosinstance";
import { CiCircleInfo, CiEdit } from "react-icons/ci";
import { IoCloseOutline } from "react-icons/io5";
import { PiSortAscendingThin } from "react-icons/pi";

function SystemUsers({ isSidebarExpanded }) {
  const navigate = useNavigate();
  const [users, setUsers] = useState([]); // State to hold user data
  const [loading, setLoading] = useState(true); // State for loading
  const [error, setError] = useState(null); // State for error handling
  const [searchVisible, setSearchVisible] = useState(false); // Toggle search bar
  const [searchQuery, setSearchQuery] = useState(""); // Store search input
  const [isSortPopup, setIsSortPopup] = useState(false); // Sort popup state
  const containerRef = useRef(null);
  const [selectedFirms, setSelectedFirms] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [isDeletePopup, setIsDeletePopup] = useState(false);
  const [isChecked, setChecked] = useState(false);
  const [sortConfig, setSortConfig] = useState({ key: "", direction: "asc" });

  const handleCheckboxChange = (userId) => {
    setSelectedFirms((prevSelected) => {
      const updatedSelected = prevSelected.includes(userId)
        ? prevSelected.filter((id) => id !== userId)
        : [...prevSelected, userId];

      setSelectAll(updatedSelected.length === users.length);
      return updatedSelected;
    });
  };
  // Handle 'Select All' checkbox change
  const handleSelectAll = () => {
    if (selectAll) {
      setSelectedFirms([]); // Unselect all
    } else {
      setSelectedFirms(users.map((user) => user.user_id)); // Select all user IDs
    }
    setSelectAll(!selectAll);
  };

  useEffect(() => {
    setSelectAll(selectedFirms.length === users.length);
  }, [selectedFirms, users]);

  const handleSortpopup = () => {
    setIsSortPopup(!isSortPopup);
  };

  // Fetch users from the API
  const fetchUsers = async (status = "Archive") => {
    try {
      const res = await axiosInstance.get(
        `/api/get_all_user_of_firm?page_status=${status}`
      );

      setUsers(res.data?.data || []);
    } catch (err) {
      console.error("Error fetching users:", err);
      setError("Error fetching users. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  const handleArchivedTable = () => {
    navigate("/archived-users"); // Navigate to the archived users page
  };
  const handleDeletePopup = () => {
    setIsDeletePopup(true);
  };

  const handleSearch = async (e, status = "Archive") => {
    const query = e.target.value;
    setSearchQuery(query); // Update search query state

    if (query.trim() === "") {
      // If search query is empty, fetch all data
      fetchUsers();
    } else {
      try {
        setLoading(true); // Start loading

        const res = await axiosInstance.get(
          `/api/search_system_user?page_status=${status}`,
          { params: { query } }
        );
        setUsers(res.data.data || []); // Update state with filtered data
        setLoading(false); // Stop loading
      } catch (error) {
        console.error("Error fetching search results:", error.message);
        setLoading(false); // Stop loading on error
      }
    }
  };

  const handleEdit = (user_id) => {
    navigate(`/edit-system-user/${user_id}`);
  };

  const handleArchivedUser = async () => {
    try {
      const res = await axiosInstance.put(`/api/archive_system_user`, {
        ids: selectedFirms,
      });

      if (res.status === 200) {
        await fetchUsers();

        setSelectedFirms([]);
        setSelectAll(false);
      } else {
        alert("Failed to archive firms. Please try again.");
      }
    } catch (error) {
      console.error("Error archiving firms:", error);
      alert("An error occurred while archiving firms.");
    }

    setIsDeletePopup(false);
  };

  const handleCancel = () => {
    setIsDeletePopup(false);
  };

  const handleRestoreUserss = async () => {
    // Add async
    try {
      const res = await axiosInstance.put(`/api/unarchive_system_user`, {
        ids: selectedFirms,
      });

      if (res.ok) {
        // showSnackbar("Department restored successfully");
        fetchUsers();
        navigate("/system-users");
        setSelectAll(false);
        setChecked(false);
      } else {
        console.error("Failed to restore departments");
      }
    } catch (error) {
      console.error("An error occurred while restoring departments:", error);
    }
  };
  const handleSort = (key) => {
    // If the same column is clicked again, toggle the direction.
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }

    const sortedRecords = [...users].sort((a, b) => {
      let aValue = a[key];
      let bValue = b[key];

      // Special handling for date fields

      // Compare the values and return the sort order.
      if (aValue < bValue) return direction === "asc" ? -1 : 1;
      if (aValue > bValue) return direction === "asc" ? 1 : -1;
      return 0;
    });

    // Update the sort configuration and set the sorted clients
    setSortConfig({ key, direction });
    setUsers(sortedRecords);
  };
  return (
    <div
      className={`table-container archived-system-users-page ${
        isSidebarExpanded ? "expanded" : "collapsed"
      }`}
    >
      <div className="table-container-content archived-system-users-content">
        <div className="table-header">
          {selectedFirms.length > 0 ? (
            <div className="table-header-content archive-header">
              <button className="delete" onClick={handleRestoreUserss}>
                Unarchive
              </button>

              <button
                className="action-header-close-button"
                onClick={() => setSelectedFirms([])}
              >
                <IoCloseOutline className="action-header-close-icon" />
              </button>
            </div>
          ) : (
            <div className="table-header-content">
              <div className="table-left-side">
                <div
                  onClick={() => navigate(-1)} // Navigate back to the previous page
                  className="back-button"
                >
                  <IoIosArrowRoundBack />
                </div>
                <h2 className="jost-bold">Archived Users</h2>
              </div>
              <div className="table-right-side">
                <div className="search-bar-container">
                  <input
                    type="text"
                    placeholder="Search ..."
                    className="search-bar"
                    value={searchQuery}
                    onChange={handleSearch} // Use handleSearch to update search query and fetch data
                  />
                  <IoIosSearch className="search-bar-icon" />
                </div>
                <button
                  className="archived-system-users-sort-button"
                  onClick={handleSortpopup}
                >
                  <span className="action-icon">
                    <PiSortAscendingThin />
                  </span>
                </button>
                {isSortPopup && (
                  <div className="sort-popup-container" ref={containerRef}>
                    <div className="sort-popup-header">
                      <span className="sort-title">Sort By</span>
                    </div>
                    <div className="sort-popup-content">
                      <button
                        className="sort-button sort-button-options"
                        onClick={() => handleSort("users_name")}
                      >
                        Name
                      </button>
                      <button
                        className="sort-button sort-button-options"
                        onClick={() => handleSort("users_email")}
                      >
                        Email
                      </button>

                      <button
                        className="sort-button sort-button-options"
                        onClick={() => handleSort("role")}
                      >
                        Role
                      </button>
                    </div>
                    <button
                      className="archive-button"
                      onClick={handleArchivedTable}
                    >
                      Archived System Users
                    </button>
                  </div>
                )}
              </div>
            </div>
          )}
        </div>

        <div className="data-list-body archived-system-users-data-body">
          <div className="data-list-scroll-body archived-system-users-scroll-body">
            <div className="data-list-table">
              {loading ? (
                <p>Loading...</p>
              ) : error ? (
                <p>{error}</p>
              ) : (
                <table className="table multilevel-data archived-system-users-table">
                  <thead className="sticky-header">
                    <tr className="table-row">
                      <th>
                        <input
                          type="checkbox"
                          checked={selectAll}
                          onChange={handleSelectAll}
                        />
                      </th>
                      <th>Sr. No</th>
                      <th>NAME</th>
                      <th>EMAIL</th>
                      <th>PHONE NUMBER</th>
                      <th>ROLE</th>
                      {/* <th>ACTION</th> */}
                    </tr>
                  </thead>
                  <tbody className="data-list-scroll-bodys">
                    {users.map((user, index) => (
                      <tr key={user.id} className="hoverable-row">
                        <td>
                          <input
                            type="checkbox"
                            checked={selectedFirms.includes(user.user_id)}
                            onChange={() => handleCheckboxChange(user.user_id)}
                          />
                        </td>
                        <td>{index + 1}</td>
                        <td>{user.users_name}</td>
                        <td>{user.users_email}</td>
                        <td>{user.contact_number}</td>
                        <td>{user.role}</td>
                        {/* <td className="center-align">
                          <div className="action-btn">
                            <span
                              className="action-icon"
                              onClick={() => handleEdit(user.user_id)}
                            >
                              <CiEdit />
                            </span>
                          </div>
                        </td> */}
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SystemUsers;
